import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const getRoleHome = (userInfo, hospitalInfo) => {
  if (userInfo?.userType === "user" && userInfo?.userDocument?.isAdmin) {
    return "/admin-dashboard";
  }
  if (hospitalInfo?.userType === "hospital") {
    return "/hospital-dashboard";
  }
  if (userInfo?.userType === "user") {
    return "/user-dashboard";
  }
  return "/login";
};

export function UserProtected({ children }) {
  const userInfo = useSelector((state) => state.user.userInfo);
  const hospitalInfo = useSelector((state) => state.hospital.hospitalInfo);

  const isAdmin = Boolean(userInfo?.userDocument?.isAdmin);
  const isUser = Boolean(userInfo?.userType === "user" && !isAdmin);

  if (!isUser) {
    return <Navigate to={getRoleHome(userInfo, hospitalInfo)} replace />;
  }

  return children;
}

export function HospitalProtected({ children }) {
  const location = useLocation();
  const userInfo = useSelector((state) => state.user.userInfo);
  const hospitalInfo = useSelector((state) => state.hospital.hospitalInfo);

  const isHospital = Boolean(hospitalInfo?.userType === "hospital");
  const requiresPlanSelection = Boolean(hospitalInfo?.requiresPlanSelection);

  if (!isHospital) {
    return <Navigate to={getRoleHome(userInfo, hospitalInfo)} replace />;
  }

  if (requiresPlanSelection) {
    return (
      <Navigate
        to={`/hospital-pricing?select=1&return=${encodeURIComponent(
          location.pathname || "/hospital-dashboard"
        )}`}
        replace
      />
    );
  }

  return children;
}

export function AdminProtected({ children }) {
  const userInfo = useSelector((state) => state.user.userInfo);
  const hospitalInfo = useSelector((state) => state.hospital.hospitalInfo);

  const isAdmin = Boolean(
    userInfo?.userType === "user" && userInfo?.userDocument?.isAdmin
  );

  if (!isAdmin) {
    return <Navigate to={getRoleHome(userInfo, hospitalInfo)} replace />;
  }

  return children;
}
